import * as z from 'zod'
import { SubscriptionType } from '../../service/Product/ProductService'

export const vimeoVideoDetailsSchema = z.object({
  vimeoIds: z
    .object({
      sub: z.nativeEnum(SubscriptionType),
      vimeoId: z.string(),
      productId: z.string()
    })
    .array()
})
